import { SVGPropsIcon } from 'src/types';

export const SignUpIcon = (props: SVGPropsIcon) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_25877_1779)">
      <path
        d="M9.53473 8.96164C11.6442 8.96164 13.3542 7.25162 13.3542 5.1422C13.3542 3.03278 11.6442 1.32275 9.53473 1.32275C7.42531 1.32275 5.71529 3.03278 5.71529 5.1422C5.71529 7.25162 7.42531 8.96164 9.53473 8.96164Z"
        fill="#F1F5F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.655 18.2926C9.82031 17.3996 9.30974 16.2 9.30974 14.8819C9.30974 13.5367 9.84192 12.3155 10.7062 11.416C10.3165 11.3864 9.91634 11.3704 9.50981 11.3704C6.85133 11.3704 4.49775 12.0354 3.03647 13.0317C1.9217 13.792 1.3071 14.7579 1.3071 15.7718V16.933C1.3071 17.2931 1.45035 17.6396 1.70563 17.8949C1.96091 18.1494 2.30663 18.2934 2.66755 18.2934L10.655 18.2926Z"
        fill="#ECFEFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.315 10.6802C11.9958 10.6802 10.1136 12.5624 10.1136 14.8816C10.1136 17.2007 11.9958 19.083 14.315 19.083C16.6342 19.083 18.5164 17.2007 18.5164 14.8816C18.5164 12.5624 16.6342 10.6802 14.315 10.6802ZM14.9152 14.2814V13.4811C14.9152 13.1498 14.6463 12.8809 14.315 12.8809C13.9837 12.8809 13.7148 13.1498 13.7148 13.4811V14.2814H12.9145C12.5832 14.2814 12.3143 14.5503 12.3143 14.8816C12.3143 15.2129 12.5832 15.4818 12.9145 15.4818H13.7148V16.282C13.7148 16.6133 13.9837 16.8822 14.315 16.8822C14.6463 16.8822 14.9152 16.6133 14.9152 16.282V15.4818H15.7155C16.0468 15.4818 16.3157 15.2129 16.3157 14.8816C16.3157 14.5503 16.0468 14.2814 15.7155 14.2814H14.9152Z"
        fill="#ECFEFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_25877_1779">
        <rect width="18.3333" height="18.3333" fill="white" transform="translate(0.75 0.75)" />
      </clipPath>
    </defs>
  </svg>
);
